import { Link } from 'react-router-dom';
import { trackEvent } from '../../lib/analytics';

const trackOutbound = (target: string) =>
  trackEvent('outbound_click', { target, page: 'prepa-post-bac' });

const Footer = () => (
  <footer className="ppb-footer">
    <div className="container ppb-footer-inner">
      <div className="ppb-footer-brand">
        <img src="/logo-gssanaa.webp" alt="" className="ppb-footer-mark" />
        <div>
          <p className="ppb-footer-school">Groupe Scolaire Sanaa</p>
          <p className="ppb-footer-loc">Prépa Post-Bac · Casablanca</p>
        </div>
      </div>
      <div className="ppb-footer-links">
        <a href="tel:0522930408" onClick={() => trackOutbound('phone')} className="ppb-footer-phone-link">
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
          </svg>
          05 22 93 04 08
        </a>
        <Link to="/politique-confidentialite">Politique de confidentialité</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
